(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/assets/javascripts/views/system-row-container.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/assets/javascripts/views/system-row-container.js');

'use strict';

svs.vikinglotto.components.play.views.SystemRowContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardContainerRegion: '#boardContainerRegion',
    systemSummaryRegion: '#systemSummaryRegion'
  },
  template(data) {
    return svs.vikinglotto.components.play.templates.system_row_container(data);
  },
  onRender() {
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model,
      className: 'board-container-vikinglotto board-container-vikinglotto-system',
      boardButtonsView: svs.numbergames.game.views.BoardButtonsSystem
    }));
    this.showChildView('systemSummaryRegion', new svs.numbergames.game.views.SystemSummary({
      model: this.model,
      ballRowType: svs.tur.ball.row.Vikinglotto,
      ballRowSize: svs.core.detect.breakpoint.greaterThan('xs') ? 300 : 200,
      className: 'number-games-system-summary-vikinglotto'
    }));
  }
});

 })(window);